import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-gtc-standalone',
    templateUrl: './gtc-standalone.component.html',
    styleUrls: ['./gtc-standalone.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GtcStandaloneComponent {

}
